import { useCallback } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import { Config } from '@surglogs-app/types'

const RECAPTCHA_ACTION = 'login'

export const useReCaptchaToken = ({
  config,
}: {
  config: Pick<Config, 'reCaptchaKey'>
}) => {
  const testEnv =
    window.Cypress || window.Playwright || process.env.NODE_ENV === 'test'
  const { executeRecaptcha } = useGoogleReCaptcha()
  const reCaptchaKey = !testEnv ? config.reCaptchaKey : undefined

  const getReCaptchaToken = useCallback(async () => {
    if (!executeRecaptcha || testEnv) {
      return null
    }

    try {
      const recaptchaResult = await executeRecaptcha(RECAPTCHA_ACTION)

      return recaptchaResult
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }, [executeRecaptcha, testEnv])

  return [getReCaptchaToken, reCaptchaKey] as [
    () => Promise<string | null | undefined>,
    string | undefined,
  ]
}
